























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { focusNext, toASCII } from "@/service/util";
import { ElInput } from "element-ui/types/input";
@Component
export default class InputNumber extends Vue {
  @Prop() maxlength: number;
  @Prop() index: number;
  @Prop() value: number;
  @Prop() readonly: any;
  @Prop() disabled: any;
  @Prop() className: string;
  @Prop() styleInput: string;
  // @Prop({ default: true }) thousandSeparate: boolean;
  @Prop({ default: "thousand" })
  mode: string; // mode number output
  @Prop({ default: 1 })
  maxDigi: number; // mode 'digit' must have maxDigi default 1
  @Prop() padnumber: number; // mode 'padnumber' zero prefix
  @Prop({ default: -1 })
  maxNumLength: number;
  @Prop({ default: "medium" })
  size: string;
  @Prop() placeholder: string;

  @Prop({ default: false })
  autofocus: boolean;
  @Prop({ default: false })
  naturalNum: boolean;
  @Prop({ default: true })
  showZero!: boolean;
  @Prop({ default: false })
  dealZero!: boolean; //showZeroに加えて入力も0扱いを優先する

  public currentValue: any = null;
  public displayValue: any = "";
  timerSelect: any = null;
  isEmit: boolean = false;

  isFocusing: boolean = false;

  $refs!: {
    input: ElInput;
  };

  @Watch("value")
  onValueChange(value: any, oldVal: any) {
    if (this.isEmit) {
      this.isEmit = false;
    } else {
      this.initValue(value);
    }
  }

  created() {
    this.initValue(this.value);
    if( this.dealZero ) this.showZero = true;
  }

  mounted() {
    setTimeout(() => {
      if (this.autofocus) {
        this.focus();
      }
    }, 100);
  }

  initValue(value: any) {
    if (value != null) {
      this.value = value;
      this.displayValue = this.value.toString();
      this.textToNumber();
      this.setCurrentValue(false);
      this.numberToText();
    } else {
      this.currentValue = null;
      this.displayValue = null;
      this.$nextTick(() => {
        this.displayValue = "";
      });
    }
    // this.emitValue();
  }

  textToNumber() {
    if (this.displayValue) {
      const number = this.displayValue
        .replace(/[^-.[0-9]/g, "") // allow number - + .
        .replace(/(?!^)-/g, ""); // check negative prefix
      if (this.mode === "digit") {
        this.displayValue = number.replace(/(\..*)\./g, "$1");
      } else if (
        this.mode != "padnumber" &&
        this.mode != "digit" &&
        !this.dealZero &&
        this.currentValue != null
      ) {
        this.displayValue = number.replace(/^0+/g, "");
      }
    }
  }

  numberToText(e: any = null) {
    const patt = /[\uFF0B-\uFF5A]/g;
    if (e && patt.test(e.target.value)) {
      let strInput = toASCII(e.target.value).replace(/[^-.[0-9]/g, "");
      let num = Number(strInput);
      this.currentValue = !isNaN(num) ? num : 0;
      this.displayValue = strInput;
      this.emitValue();
    } else if (e && e.target.value) {
      let num = parseFloat(e.target.value.replace(/[^-.[0-9]/g, ""));
      if (num != this.currentValue) {
        this.currentValue = !isNaN(num) ? num : 0;
        this.emitValue();
      }
    }
    if (isNaN(this.currentValue)) {
      this.currentValue = null;
      this.emitValue();
    }
    if (this.currentValue == null && !this.isFocusing) {
      if (this.showZero) {
        this.$nextTick(() => {
          if (this.mode === "digit" && !this.naturalNum && this.maxDigi > -1) {
            this.displayValue = (0).toFixed(this.maxDigi);
          } else {
            this.displayValue = "0";
          }
        });
      } else {
        this.$nextTick(() => {
          this.displayValue = "";
        });
      }
    } else {
      if (this.mode === "thousand" && !this.isFocusing) {
        if (this.currentValue == 0) {
          if (this.readonly || !this.showZero) {
            this.displayValue = "";
          } else {
            this.displayValue = "0";
          }
          this.emitValue();
        } else {
          let txt = this.currentValue
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          this.displayValue = null;
          this.$nextTick(() => {
            this.displayValue = txt;
          });
        }
      } else if (this.mode === "digit" && this.maxDigi > -1) {
        if (!this.isFocusing) {
          if (!this.naturalNum) {
            this.displayValue = this.currentValue.toFixed(this.maxDigi);
          } else {
            this.displayValue = parseFloat(this.currentValue).toString();
          }
        }
      } else if (
        this.mode === "padnumber" &&
        this.padnumber &&
        +this.displayValue > 0
        && !this.isFocusing
      ) {
        this.displayValue = this.displayValue.padStart(this.padnumber, "0");
      }
    }
  }

  onInput(e: any) {
    this.textToNumber();
    this.setCurrentValue();
    this.numberToText();
    this.$emit("onInput");
  }

  onKeypress(e: any) {
    e.target.value = e.target.value.replace(/．/g, '.');
    let el = document.activeElement as any;
    if (el.selectionStart != el.selectionEnd) {
      return true;
    } else if (this.maxNumLength > -1) {
      if (this.mode == "digit") {
        if (
          e.target.value.split(".")[0].length >= this.maxNumLength &&
          (e.code.indexOf("Digit") > -1 ||
            (e.code.indexOf("NumpadDecimal") == -1 &&
              e.code.indexOf("Numpad") > -1)) &&
          e.target.value[e.target.value.length - 1] != "."
        ) {
          e.preventDefault();
        } else if (e.target.value.indexOf(".") > -1) {
          const arr = e.target.value.slice(e.target.value.indexOf("."));
          if (
            arr.length >= this.maxDigi &&
            (e.code.indexOf("Digit") > -1 || e.code.indexOf("Numpad") > -1)
          ) {
            this.goNextInput();
          }
        }
      }
    } else {
      let num = e.target.value;
      if (this.mode == "thousand") {
        num = num.replace(/^0+/g, "");
      }
      if (num.length == +this.maxlength - 1) {
        this.goNextInput();
      }
    }
  }

  goNextInput() {
    setTimeout(() => {
      this.blur();
      focusNext(this.index);
    }, 0);
  }

  setCurrentValue(doEmit: boolean = true) {
    const str = this.displayValue.replace(/,/g, "");
    this.currentValue = Number(str);
    if( this.dealZero && str == ""){
      this.currentValue = 0;
      this.displayValue = "0";
    }else if (isNaN(Number(str)) || str == "") {
      this.currentValue = null;
    } else {
      this.currentValue = Number(str);
    }
    if (doEmit) {
      this.emitValue();
    }
  }

  clearTimerSelect() {
    if (this.timerSelect) {
      clearTimeout(this.timerSelect);
      this.timerSelect = null;
    }
  }

  onEnter(e: any) {
    this.clearTimerSelect();
    this.goNextInput();
    this.$emit("onEnter", e);
  }

  onFocus() {
    this.isFocusing = true;
    this.clearTimerSelect();
    if (!this.readonly) {
      this.textToNumber();
      this.timerSelect = setTimeout(() => {
        this.$refs.input.select();
      }, 200);
    }
  }

  onBlur(event: any) {
    this.isFocusing = false;
    if (!this.readonly) {
      this.clearTimerSelect();
      this.numberToText(event);
      if (this.mode == "padnumber") {
        this.emitValue();
      }
      this.$emit("focusout", this.currentValue);
    }
  }

  getValue() {
    return this.currentValue;
  }

  focus() {
    this.$refs.input.focus();
  }

  blur() {
    this.$refs.input.blur();
  }

  onChange(val: any) {
    this.$emit("change", this.currentValue);
  }

  emitValue() {
    if (!this.readonly && !this.disabled) {
      if (this.value == this.currentValue) {
        return;
      }
      this.isEmit = true;
      this.$emit(
        "input",
        this.mode == "padnumber" ? this.displayValue : this.currentValue
      );
    }
  }

  onKeydown(e: any) {
    if (
      [46, 8, 9, 27, 13, 92, 110, 190].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode == 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode == 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode == 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode == 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }

    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || (e.keyCode > 105 && e.keyCode)) // 109 key minus
    ) {
      e.preventDefault();
    }
  }
}
